import { render } from "./logos.vue?vue&type=template&id=0558771d&scoped=true"
import script from "./logos.vue?vue&type=script&lang=js"
export * from "./logos.vue?vue&type=script&lang=js"

import "./logos.vue?vue&type=style&index=0&id=0558771d&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0558771d"]])

export default __exports__